import { ReactElement } from 'react'

export type FacilityIconProps = {
	width?: string
	height?: string
	fill?: string
	stroke?: string
	className?: string
}

// Kitchen SVG Icon
export const KitchenIcon = (props: FacilityIconProps): ReactElement => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M6 5H10" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M18 5.00895V5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M3 8H21" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M2 22H22" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M3 22V5C3 2.518 3.518 2 6 2H18C20.482 2 21 2.518 21 5V22" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M6 17V13C6 12.0572 6 11.5858 6.29289 11.2929C6.58579 11 7.05719 11 8 11H16C16.9428 11 17.4142 11 17.7071 11.2929C18 11.5858 18 12.0572 18 13V17C18 17.9428 18 18.4142 17.7071 18.7071C17.4142 19 16.9428 19 16 19H8C7.05719 19 6.58579 19 6.29289 18.7071C6 18.4142 6 17.9428 6 17Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

// Wi-Fi SVG Icon
export const WifiIcon = (props: FacilityIconProps): ReactElement => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M12 18.5H12.0118" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M8.25 15.5C10.25 13.5 13.75 13.5 15.75 15.5" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M18.5 12.5C14.7324 9.16667 9.5 9.16667 5.5 12.5" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M2 9.5C8.31579 4.16669 15.6842 4.16668 22 9.49989" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
	</svg>
)

// Air Conditioned SVG Icon
export const AirConditionedIcon = (props: FacilityIconProps): ReactElement => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M2 5.94145C5.5 9.37313 10.5755 7.90241 11.7324 5.94145C11.9026 5.65301 12 5.31814 12 4.96096C12 3.87795 11.1046 3 10 3C8.89543 3 8 3.87795 8 4.96096" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M17 8.92814C17 7.31097 18.1193 6 19.5 6C20.8807 6 22 7.31097 22 8.92814C22 9.6452 21.7799 10.3021 21.4146 10.8111C19.3463 14.1915 9.2764 12.9164 4 11.8563" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M13.0854 19.8873C13.2913 20.5356 13.8469 21 14.5 21C15.3284 21 16 20.2528 16 19.331C16 19.0176 15.9224 18.7244 15.7873 18.4738C14.4999 15.9925 7.99996 14.3239 2 18.7746" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M19 15.5H21" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

// No Smoking SVG Icon
export const NoSmokingIcon = (props: FacilityIconProps): ReactElement => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17.9998 15V18M17.9998 12C17.9998 11 17 8.99981 15 8.99981H14C13.2044 8.99981 12.4413 8.68374 11.8787 8.12113C11.3161 7.55852 11 6.79546 11 5.99981V4.26777C11 3.60473 11.2634 2.96884 11.7322 2.5C12.2011 2.03116 12.837 1.76777 13.5 1.76777H14M20.9998 12C20.9998 7.50004 18.9998 6.50004 16.9998 6.00004C18.9998 5.50004 20.9998 5.00004 20.9998 2.00004M20.9998 15V18" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M15 15H3.6C3.26863 15 3 15.2686 3 15.6V17.4C3 17.7314 3.26863 18 3.6 18H17.1686C17.5 18 17.7686 17.7314 17.7686 17.4" stroke="black" strokeWidth="1.5"/>
		<path d="M3 3L21 21" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

// Parking SVG Icon
export const ParkingIcon = (props: FacilityIconProps): ReactElement => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="black" strokeWidth="1.5"/>
		<path d="M9 13V8.4C9 8.02774 9 7.84162 9.04894 7.69098C9.14786 7.38655 9.38655 7.14786 9.69098 7.04894C9.84162 7 10.0277 7 10.4 7H13C14.6569 7 16 8.34315 16 10C16 11.6569 14.6569 13 13 13H9ZM9 13V18" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

// Pet Friendly SVG Icon
export const PetFriendlyIcon = (props: FacilityIconProps): ReactElement => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21.4565 7.97344C21.2899 7.90795 21.1124 7.87455 20.9334 7.875H20.9146C19.9691 7.88906 18.9088 8.77453 18.3524 10.1138C17.6854 11.7159 17.9924 13.3552 19.0434 13.7766C19.2098 13.8421 19.3871 13.8755 19.566 13.875C20.5162 13.875 21.591 12.9844 22.1521 11.6363C22.8144 10.0341 22.5027 8.39484 21.4565 7.97344ZM15.3562 14.2256C14.053 12.0633 13.4905 11.25 11.9999 11.25C10.5093 11.25 9.9421 12.0684 8.63898 14.2256C7.52335 16.0706 5.26866 16.2244 4.70616 17.7914C4.59204 18.0784 4.53473 18.3849 4.53741 18.6937C4.53741 19.9683 5.51241 21 6.71241 21C8.20304 21 10.2327 19.8098 12.0046 19.8098C13.7765 19.8098 15.7968 21 17.2874 21C18.4874 21 19.4577 19.9687 19.4577 18.6937C19.4588 18.3846 19.3999 18.0781 19.2843 17.7914C18.7218 16.2187 16.4718 16.0706 15.3562 14.2256ZM9.02382 9.1875C9.08659 9.18756 9.14927 9.18286 9.21132 9.17344C10.2993 9.01547 10.9785 7.50797 10.7319 5.80547C10.4999 4.20047 9.52585 3 8.50726 3C8.44449 2.99994 8.38181 3.00465 8.31976 3.01406C7.23179 3.17203 6.55257 4.67953 6.79913 6.38203C7.03116 7.98234 8.00523 9.1875 9.02382 9.1875ZM17.1993 6.38203C17.4459 4.67953 16.7666 3.17203 15.6787 3.01406C15.6166 3.00465 15.5539 2.99994 15.4912 3C14.4726 3 13.5004 4.20047 13.2679 5.80547C13.0213 7.50797 13.7005 9.01547 14.7885 9.17344C14.8506 9.18286 14.9132 9.18756 14.976 9.1875C15.9946 9.1875 16.9687 7.98234 17.1993 6.38203ZM4.95788 13.7766C6.00741 13.3547 6.31398 11.7141 5.64788 10.1138C5.08726 8.76563 4.01335 7.875 3.0646 7.875C2.88573 7.8745 2.70838 7.9079 2.54195 7.97344C1.49241 8.39531 1.18585 10.0359 1.85195 11.6363C2.41257 12.9844 3.48648 13.875 4.43523 13.875C4.6141 13.8755 4.79145 13.8421 4.95788 13.7766Z" stroke="black" strokeWidth="1.5" strokeMiterlimit="10"/>
	</svg>
)

// Washing Machine SVG Icon
export const WashingMachineIcon = (props: FacilityIconProps): ReactElement => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M3 14V10C3 6.22876 3 4.34315 4.17157 3.17157C5.34315 2 7.22876 2 11 2H13C16.7712 2 18.6569 2 19.8284 3.17157C21 4.34315 21 6.22876 21 10V14C21 17.7712 21 19.6569 19.8284 20.8284C18.6569 22 16.7712 22 13 22H11C7.22876 22 5.34315 22 4.17157 20.8284C3 19.6569 3 17.7712 3 14Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M7 6V6.01" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M17 13C17 15.7614 14.7614 18 12 18C9.23858 18 7 15.7614 7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M7 13C8.66667 11.6667 10.3333 11.6667 12 13C13.6667 14.3333 15.3333 14.3333 17 13" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

// Self Check-In SVG Icon
export const SelfCheckInIcon = (props: FacilityIconProps): ReactElement => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M8.5 14.5C5.1863 14.5 2.5 11.8137 2.5 8.5C2.5 5.18629 5.1863 2.5 8.5 2.5C11.8137 2.5 14.5 5.18629 14.5 8.5C14.5 9.38041 14.3104 10.2165 13.9697 10.9697L20.9142 17.9142C21.2893 18.2893 21.5 18.798 21.5 19.3284V21.5H18.5V19.5H16.5V17.5H14.5L10.9697 13.9697C10.2165 14.3104 9.3804 14.5 8.5 14.5Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M6.5 6.5L7.5 7.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

// Cribs Available SVG Icon
export const CribsAvailableIcon = (props: FacilityIconProps): ReactElement => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M12 7V15M8 7V15M16 7V15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M20 20V6C20 4.89543 20.8954 4 22 4M4 20V6C4 4.89543 3.10457 4 2 4" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M4 7H20" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M4 15H20" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M4 18H20" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

// Wheelchair SVG Icon
export const WheelchairIcon = (props: FacilityIconProps): ReactElement => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M12 16C12 18.7614 9.76142 21 7 21C4.23858 21 2 18.7614 2 16C2 13.2386 4.23858 11 7 11C9.76142 11 12 13.2386 12 16Z" stroke="black" strokeWidth="1.5"/>
		<path d="M18 19.5C18 20.3284 17.3284 21 16.5 21C15.6716 21 15 20.3284 15 19.5C15 18.6716 15.6716 18 16.5 18C17.3284 18 18 18.6716 18 19.5Z" stroke="black" strokeWidth="1.5"/>
		<path d="M7.00899 16H7" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M6 11L5.3721 5.97683C5.2273 4.81842 5.1549 4.23921 4.85048 3.82169C4.67889 3.58637 4.45799 3.39136 4.2032 3.25029C3.75115 3 3.16743 3 2 3" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M6 7H11.5C13.857 7 15.0355 7 15.7678 7.73223C16.5 8.46447 16.5 9.64298 16.5 12V18" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
		<path d="M12 14H16.0241C16.909 14 17.3515 14 17.7374 14.1887C17.8297 14.2339 17.9188 14.2867 18.0039 14.3468C18.3597 14.5978 18.6052 15.0057 19.096 15.8214C19.489 16.4745 19.6855 16.8011 19.9799 16.9279C20.0491 16.9578 20.1212 16.9789 20.1947 16.9911C20.5071 17.0428 20.8239 16.8673 21.4576 16.5163L22 16.2158" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
	</svg>
)

// Elevator SVG Icon
export const ElevatorIcon = (props: FacilityIconProps): ReactElement => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M7 21.5V14.7763C7 13.5656 7.63286 12.4894 8.7 12.2815C9.48714 12.1279 10.5714 12 12 12M17 21.5V14.7763C17 13.5656 16.3671 12.4894 15.3 12.2815C14.5143 12.1279 13.4286 12 12 12M12 12V21.9952" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M7 8L8.66667 6L10.3333 8M13.6667 6L15.3333 8L17 6" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M3 14V10C3 6.22876 3 4.34315 4.17157 3.17157C5.34315 2 7.22876 2 11 2H13C16.7712 2 18.6569 2 19.8284 3.17157C21 4.34315 21 6.22876 21 10V14C21 17.7712 21 19.6569 19.8284 20.8284C18.6569 22 16.7712 22 13 22H11C7.22876 22 5.34315 22 4.17157 20.8284C3 19.6569 3 17.7712 3 14Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

// Facility name to icon mapping
export enum FacilityName {
	KITCHEN = 'kitchen',
	WIFI = 'freeWifi',
	AIR_CONDITIONED = 'airConditioned',
	NO_SMOKING = 'noSmoking',
	PARKING = 'freeParking',
	PET_FRIENDLY = 'petFriendly',
	WASHING_MACHINE = 'laundryFacilities',
	SELF_CHECK_IN = 'selfCheckIn',
	CRIBS_AVAILABLE = 'cribsAvailable',
	WHEELCHAIR = 'wheelchairAccessible',
	ELEVATOR = 'elevator',
	// Add more facility names here as needed
}

/**
 * Maps facility names to their corresponding SVG icon components
 * Returns the icon component with appropriate size for mobile filters
 */
export const getFacilityIcon = (facilityName: string): ReactElement | null => {
	const iconProps = {
		width: '24px',
		height: '24px',
		className: 'facility-icon'
	}

	switch (facilityName) {
		case FacilityName.KITCHEN:
			return <KitchenIcon {...iconProps} />
		case FacilityName.WIFI:
			return <WifiIcon {...iconProps} />
		case FacilityName.AIR_CONDITIONED:
			return <AirConditionedIcon {...iconProps} />
		case FacilityName.NO_SMOKING:
			return <NoSmokingIcon {...iconProps} />
		case FacilityName.PARKING:
			return <ParkingIcon {...iconProps} />
		case FacilityName.PET_FRIENDLY:
			return <PetFriendlyIcon {...iconProps} />
		case FacilityName.WASHING_MACHINE:
			return <WashingMachineIcon {...iconProps} />
		case FacilityName.SELF_CHECK_IN:
			return <SelfCheckInIcon {...iconProps} />
		case FacilityName.CRIBS_AVAILABLE:
			return <CribsAvailableIcon {...iconProps} />
		case FacilityName.WHEELCHAIR:
			return <WheelchairIcon {...iconProps} />
		case FacilityName.ELEVATOR:
			return <ElevatorIcon {...iconProps} />
		// Add more cases here for other facilities
		default:
			return null
	}
}

/**
 * Get all available facility icons
 * Useful for mapping over all facilities
 */
export const getAllFacilityIcons = () => ({
	kitchen: KitchenIcon,
	wifi: WifiIcon,
	airConditioned: AirConditionedIcon,
	noSmoking: NoSmokingIcon,
	parking: ParkingIcon,
	petFriendly: PetFriendlyIcon,
	washingMachine: WashingMachineIcon,
	selfCheckIn: SelfCheckInIcon,
	cribsAvailable: CribsAvailableIcon,
	wheelchair: WheelchairIcon,
	elevator: ElevatorIcon,
	// Add more icon exports here as you add new SVGs
})
